<template>
  <span>
    <span>in Table</span>
    <b-form-select
      v-model="workflow.sourceGrid"
      :options="dataGrid_select"
      size="sm"
      @change="sourceGridSelected"
    />

    <div class="mt-2" />

    <div v-if="workflow.sourceGrid">
      <Action
        v-for="(action, idx) in workflow.actions"
        :key="idx"
        :eventBus="eventBus"
        :actionIdx="idx"
        :actionType="action.type"
        :availableActions="availableActions"
        @actionSelected="actionSelected"
      >
        <AddRowTo
          v-if="action.type === 'addRowTo'"
          :eventBus="eventBus"
          :action="action"
          :actionIdx="idx"
          :sourceGrid="workflow.sourceGrid"
        />

        <UpdateCreatedRow
          v-if="action.type === 'updateCreatedRow'"
          :eventBus="eventBus"
          :action="action"
          :actionIdx="idx"
          :sourceGrid="workflow.sourceGrid"
        />
      </Action>
    </div>

    <AddActionBtn
      v-if="workflow.sourceGrid && workflow.actions"
      :eventBus="eventBus"
      :actionsCount="workflow.actions.length"
    />
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
// components
import AddActionBtn from '../../AddActionBtn'
import Action from '../../Action'
import AddRowTo from './actions/AddRowTo'
import UpdateCreatedRow from './actions/UpdateCreatedRow'

export default {
  props: ['eventBus', 'workflow'],
  components: {
    AddActionBtn,
    Action,
    AddRowTo,
    UpdateCreatedRow,
  },
  computed: {
    ...mapGetters(['dataGrid_select', 'dataGrid_title']),
    availableActions() {
      return [
        { text: 'Add a new row to table', value: 'addRowTo' },
        {
          text: `Update newly created "${this.workflow.sourceGrid}" row value`,
          value: 'updateCreatedRow',
        },
      ]
    },
  },
  methods: {
    sourceGridSelected() {
      if (!this.workflow.actions) this.eventBus.$emit('addAction')
    },
    actionSelected(type, idx) {
      const curAction = this.workflow.actions[idx]

      switch (type) {
        case 'updateCreatedRow':
          this.eventBus.$emit(
            'setAction',
            Object.assign({}, curAction, { writeMethods: [{ type: 'expression' }] }),
            idx
          )
          break
      }
    },
  },
}
</script>
